var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'd-flex gmb-row',
    { 'align-items-center': !_vm.alignControlsOnTop },
    {
      'rounded-1': _vm.collapseId || _vm.isSelectable,
    },
    {
      'gmb-row--clickable': _vm.collapseId,
    },
    {
      'py-1 px-2':
        (!_vm.collapseId && !_vm.isSelectable) ||
        (!_vm.collapseId && _vm.isSelectable && _vm.isSelectableTextStyle),
    },
    {
      'p-2':
        (!_vm.collapseId && _vm.isSelectable && !_vm.isSelectableTextStyle) ||
        (_vm.collapseId && !_vm.isSelectable),
    },
    {
      'p-1': _vm.collapseId && _vm.isSelectable && _vm.isSelectableTextStyle,
    },
    {
      'gmb-row--selectable-text': _vm.isSelectable && _vm.isSelectableTextStyle,
    },
    {
      'gmb-row--selectable-area': _vm.isSelectable && !_vm.isSelectableTextStyle,
    },
    {
      'gmb-row--selected':
        _vm.isSelectable && (_vm.checkboxIsActivated || _vm.radioButtonIsActivated),
    },
  ],attrs:{"id":_vm.selfDomNodeId}},[(_vm.collapseId)?_c('div',{class:[
      'd-flex flex-column justify-content-center align-items-center gmb-row__offset-wrapper',
      { 'mt-1': _vm.alignControlsOnTop },
    ]},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(_vm.collapseId),expression:"collapseId"}],staticClass:"d-flex w-100 p-0 h-100 justify-content-center align-items-center text-size-reset rounded-1 btn-transparent-light",on:{"click":function($event){$event.stopPropagation();}}},[_c('i',{class:['fas', 'fa-angle-' + (_vm.collapseIsVisible ? 'down' : 'right')]})])],1):_vm._e(),(_vm.isSelectable)?_c('div',{class:[
      'd-flex flex-column',
      { 'pl-1': _vm.collapseId },
      { 'mt-1': _vm.alignControlsOnTop },
    ]},[_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center gmb-row__offset-wrapper"},[(_vm.isCheckbox)?_c('GmbCheckbox',{ref:"gmbCheckbox",attrs:{"switcherStyle":_vm.switcherStyle,"value":_vm.controlValue},on:{"state-changed":(newState) => _vm.onCheckboxStateChanged(newState)}}):(_vm.isRadioButton)?_c('GmbRadioButton',{ref:"gmbRadioButton",attrs:{"value":_vm.controlValue},on:{"state-changed":(newState) => _vm.onRadioButtonStateChanged(newState)}}):_vm._e()],1)]):_vm._e(),(_vm.hasPicto)?_c('div',{class:[
      'd-flex flex-column',
      { 'pl-1': _vm.collapseId || _vm.isSelectable },
      { 'mt-1': _vm.alignControlsOnTop },
    ]},[_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center gmb-row__offset-wrapper"},[_vm._t("picto")],2)]):_vm._e(),_c('div',{class:[
      'd-flex flex-grow-1 w-0 flex-column',
      { 'pl-1': _vm.collapseId || _vm.isSelectable || _vm.hasPicto },
    ]},[_vm._t("default")],2),(_vm.hasInfoSticker)?_c('div',{staticClass:"d-flex flex-column pl-1"},[_c('div',{class:[
        'd-flex flex-column justify-content-end align-items-center gmb-row__offset-wrapper',
        _vm.isStickerOffsetWidthFixed
          ? 'gmb-row__offset-wrapper--large-fixed'
          : 'gmb-row__offset-wrapper--large',
      ]},[_vm._t("infoSticker")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }